import Menu from './Menu';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';
import Header from './Header';

/**
 * Implementation of Menu for Horizontal SubMenu Navigation
 */
class HorizontalSubMenu extends Menu {

	constructor($element) {
		super($element)

		this.$menu = this.$element.find('.menu');
	}

	onReady() {
		super.onReady();

		this.toggleScrolled();
	}

	onResize() {
		super.onResize();

		this.toggleScrolled();
	}

	onScroll() {
		this.toggleScrolled();
	}

	/**
	 * Toggle the subMenus "scrolled" state
	 */
	toggleScrolled() {
		if(Settings.fixedHorizontalSubMenu) {
			// activate scrolled state when Header docks on the subMenu
			this.$element.toggleClass('scrolled', $window.scrollTop() >= this.$element.offset().top - Header.getHeight());
			this.$element.css('height', this.$menu.height());
			// set top value for fixed menu
			this.$menu.css('top', Header.getHeight());
		}
	}
}

export default (new HorizontalSubMenu($body.find('.menuSub')));